(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fpc-photo-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fpc-photo-carousel')) {
    customElements.define('fpc-photo-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('.fpc-carousel-track');
        const buttons = this.querySelectorAll('button');
        const update = () => {
          buttons[0].disabled = track.scrollLeft < 2;
          buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const step = track.querySelector('figure').getBoundingClientRect().width + 24;
          track.scrollBy({left:Number(button.dataset.direction)*step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        }));
        track.addEventListener('scroll',update,{passive:true});
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { if(this.observer) this.observer.disconnect(); this.initialized=false; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
